import React from "react";
import "./RepositoryProjects.css";
import NewRepositoryProject from "./NewRepositoryProject";
import RepositoryProjectBoard from "./RepositoryProjectBoard";
import { CustomCard, Title } from "../../Utils/UI/Text";

const RepositoryProjects = () => {
  return (
    <>
      <Title
        children={"Repositorio de Proyectos"}
        childrenTwo={<NewRepositoryProject />}
      />
      <CustomCard>
        <RepositoryProjectBoard />
      </CustomCard>
    </>
  );
};

export default RepositoryProjects;
